import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wind01 = function Wind01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 18s-1.1904-.4695-2-.6979c-5.1203-1.4447-8.8797 2.8405-14 1.3958C4.1904 18.4695 3 18 3 18m18-6s-1.1904-.4695-2-.6979c-5.1203-1.4447-8.8797 2.8405-14 1.3958C4.1904 12.4695 3 12 3 12m18-6s-1.1904-.4695-2-.698c-5.1203-1.4446-8.8797 2.8406-14 1.396C4.1904 6.4694 3 6 3 6"
    })
  }));
};
export default Wind01;